import { INVALID_TIME_MESSAGE } from '../../constants/messages';
export var validateTimeInput = function validateTimeInput(time) {
  var timeRegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;

  if (!timeRegExp.test(time)) {
    return INVALID_TIME_MESSAGE;
  }

  return undefined;
};